import { render, staticRenderFns } from "./AwardLogos.vue?vue&type=template&id=75a7cc30&scoped=true&functional=true&"
import script from "./AwardLogos.vue?vue&type=script&lang=js&"
export * from "./AwardLogos.vue?vue&type=script&lang=js&"
import style0 from "./AwardLogos.vue?vue&type=style&index=0&id=75a7cc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "75a7cc30",
  null
  
)

export default component.exports